import { appConfig } from '../../utils/appConfig';
import ProductCard, { ProductCardProps } from './_ProductCard';
import ProductCardMeater from './_ProductCardMeater';
import { classNames } from '@repo/ui/src/utils/classNames';

interface ProductListProps {
  title?: string;
  products: Array<ProductCardProps>;
  primaryHeader?: string;
  secondaryHeader?: string;
}

const ProductList = ({ products, title, primaryHeader, secondaryHeader }: ProductListProps) => {
  if (!products?.length) return null;
  const hasImages = products.some(
    (product) => product.image?.image?.url || product.image?.image?.id,
  );
  return (
    <div className="text-neutral-500 flex flex-col gap-y-4 px-4 sm:px-0">
      {title && <h5 className="tra-text-web-sub-2 md:text-xl ">{title}</h5>}
      <ul
        className={classNames(
          'grid sm:grid-cols-3 list-none pl-0',
          appConfig.isTraeger && 'gap-x-6 gap-y-5 sm:gap-y-10',
          appConfig.isMeater && 'gap-[1px]',
          !hasImages && 'grid-cols-2',
        )}
      >
        {products.filter(Boolean).map((product, i) => (
          <li key={i}>
            {appConfig.isTraeger ? (
              <ProductCard
                {...product}
                primaryHeader={primaryHeader}
                secondaryHeader={secondaryHeader}
              />
            ) : (
              <ProductCardMeater
                {...product}
                primaryHeader={primaryHeader}
                secondaryHeader={secondaryHeader}
              />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductList;
